import type { ServiceCreateRequest, ServicePriceChange } from "@shyne/shared/api";
import type { Service } from "@/models/services.model";

export type ServicePricing = { price: number; payment: number; pricedPerJob: boolean };

export const pricingOf = (service: Service): ServicePricing => ({ price: service.price, payment: service.payment, pricedPerJob: service.priced_per_job });

export function priceChangesOf(services: readonly Service[], edited: Readonly<Record<string, ServicePricing>>): ServicePriceChange[] {
  return Object.entries(edited).flatMap(([id, { price, payment, pricedPerJob }]) => {
    const service = services.find((s) => s.id === id);
    if (!service?.parent) return [];
    const marking = service.priced_per_job !== pricedPerJob;
    if (!marking && service.price === price && service.payment === payment) return [];
    return [{ service: id, price, defaultPay: payment, ...(marking ? { pricedPerJob } : {}) }];
  });
}

export type NewService = Pick<Service, "name"> & Partial<Pick<Service, "parent" | "price" | "payment" | "priced_per_job">>;

export function serviceCreateRequestOf(actingOrganization: string, { name, parent, price, payment, priced_per_job }: NewService): ServiceCreateRequest {
  if (!parent) return { actingOrganization, name };
  return { actingOrganization, name, parent, price, defaultPay: payment, ...(priced_per_job ? { pricedPerJob: true } : {}) };
}
